
<div class="error-container">
    <div class="content-container">
        <p class="main-message">We've hit a snag!</p>
        <p class="error-title">{{errorTitle}}</p>
        <p class="error-message">{{errorMessage}}</p>
    </div>
</div>